module.exports = __webpack_public_path__ + "static/media/quiz.641ab699.png";